import Headroom from 'headroom.js';
import { breakpoints } from './breakpoints';

export default function navigation() {
  if ($('.site-header.headroom').length) {
    const headroom = new Headroom(
      document.querySelector('.site-header.headroom'),
      {
        offset: 20,
        tolerance: 5,
        onPin() {
          $('body').addClass('header-headroom-pinned');
        },
        onUnpin() {
          $('body').removeClass('header-headroom-pinned');
        },
        onTop() {
          $('body').addClass('header-headroom-top');
          $('body').removeClass('header-headroom-not-top');
        },
        onNotTop() {
          $('body').removeClass('header-headroom-top');
          $('body').addClass('header-headroom-not-top');
        },
      }
    );

    headroom.init();
  }

  /**
   * Mobile navigation
   */
  const $mobileToggler = $('.nav-toggler');
  const $mobileNav = $($mobileToggler.attr('data-target'));
  let mobileNavActive = false;

  $mobileNav
    .find('.menu-item, .nav-mobile__infos > span')
    .each(function (index) {
      $(this).addClass(`menu-item-animated menu-item-animated--${index}`);
    });

  function openNav() {
    $mobileToggler.addClass('is-active');
    $('body').addClass('navbar--opened');
    mobileNavActive = true;
    if (Modernizr.touchevents) {
      scrollLock.lock();
    }
  }

  function closeNav() {
    $mobileToggler.removeClass('is-active');
    $('body').removeClass('navbar--opened');
    $('body').addClass('navbar--closing');
    setTimeout(function () {
      $('body').removeClass('navbar--closing');
    }, 500);
    mobileNavActive = false;
    if (Modernizr.touchevents) {
      scrollLock.unlock();
    }
  }

  $mobileToggler.on('click', function (e) {
    e.preventDefault();
    if (mobileNavActive) {
      closeNav();
    } else {
      openNav();
    }
  });

  /**
   * Close mobile menu when resizing window
   */
  $(window).on('resize', function (e) {
    if ($(this).width() >= breakpoints.xl) {
      // closeNav();
    }
  });

  /**
   * Close menu on item click
   */
  $mobileNav.find('a').on('click', function () {
    if (!$(this).attr('href').startsWith('#')) {
      closeNav();
    }
  });

  /**
   * Close menu on backdrop click
   */
  $('.nav-mobile__backdrop').on('click', function () {
    closeNav();
  });

  /**
   * Disabled links
   */
  $('.nav a[href="#"]')
    .addClass('disabled')
    .on('click', function (e) {
      e.preventDefault();
    });
}
